var _circle, _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#F1F3FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.1094,
    y: 57,
    width: 11.395,
    height: 1.1395,
    rx: 0.569748,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7812,
    y: 57,
    width: 5.69748,
    height: 1.1395,
    rx: 0.569748,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9531,
    y: 61.1797,
    width: 5.69748,
    height: 1.1395,
    rx: 0.569748,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5357 36C33.5154 36 35.4139 35.2098 36.8138 33.8033C38.2136 32.3968 39 30.4891 39 28.5C39 26.5109 38.2136 24.6032 36.8138 23.1967C35.4139 21.7902 33.5154 21 31.5357 21C29.5561 21 27.6575 21.7902 26.2577 23.1967C24.8578 24.6032 24.0714 26.5109 24.0714 28.5C24.0714 30.4891 24.8578 32.3968 26.2577 33.8033C27.6575 35.2098 29.5561 36 31.5357 36ZM48.5 36C49.9397 36 51.3205 35.4253 52.3386 34.4024C53.3566 33.3795 53.9286 31.9921 53.9286 30.5455C53.9286 29.0988 53.3566 27.7114 52.3386 26.6885C51.3205 25.6656 49.9397 25.0909 48.5 25.0909C47.0603 25.0909 45.6795 25.6656 44.6614 26.6885C43.6434 27.7114 43.0714 29.0988 43.0714 30.5455C43.0714 31.9921 43.6434 33.3795 44.6614 34.4024C45.6795 35.4253 47.0603 36 48.5 36ZM24.0714 38.7273C22.9916 38.7273 21.956 39.1583 21.1925 39.9255C20.429 40.6927 20 41.7332 20 42.8182V43.0227C20 43.0227 20 51 31.5357 51C43.0714 51 43.0714 43.0227 43.0714 43.0227V42.8182C43.0714 41.7332 42.6425 40.6927 41.8789 39.9255C41.1154 39.1583 40.0798 38.7273 39 38.7273H24.0714ZM48.5 48.2727C46.524 48.2727 44.9606 48.0027 43.7215 47.5732C44.3078 46.6186 44.6444 45.6982 44.8344 44.955C44.9729 44.4209 45.0606 43.8748 45.0963 43.3241C45.099 43.2695 45.1017 43.2205 45.1017 43.1782L45.1031 43.1209V42.8182C45.1055 41.3086 44.552 39.8514 43.5491 38.7273H54.7334C55.1623 38.7271 55.587 38.8118 55.9833 38.9766C56.3797 39.1414 56.7398 39.3831 57.0431 39.6877C57.3465 39.9924 57.5871 40.3542 57.7513 40.7523C57.9155 41.1505 58 41.5772 58 42.0082C58 42.0082 58 48.2727 48.5 48.2727Z",
    fill: "#CED4DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPatients);
export default __webpack_public_path__ + "static/media/EmptyPatients.b7542e3f36a7af2a31cf3fe4eb099c0b.svg";
export { ForwardRef as ReactComponent };